"use client";

import React from "react";
import { cn } from "@/lib/utils";

export default function PostCardSkeleton({
  variant: _variant = "default",
  showMeta = true,
}: {
  variant?: "default" | "light";
  showMeta?: boolean;
}) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-2xl border border-border bg-card text-card-foreground p-5 shadow-sm",
        "animate-pulse"
      )}
    >
      {/* Diagonal ribbon placeholder (top-right corner) */}
      <div aria-hidden className="pointer-events-none absolute top-0 right-0 h-24 w-24 overflow-hidden">
        <span className="absolute top-4 right-[-36px] block w-[140px] rotate-45 bg-violet-600/30 py-1 h-6" />
      </div>

      {/* Title (2-3 lines) */}
      <div className="space-y-2">
        <div className="h-6 md:h-7 w-3/4 rounded skeleton" />
        <div className="h-6 md:h-7 w-1/2 rounded skeleton" />
      </div>

      {/* Meta line */}
      <div className="mt-3 h-3 w-32 rounded skeleton" />

      {/* Divider */}
      <div className="my-4 border-t border-border" />

      {/* Footer row: avatar + name/location */}
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 shrink-0 rounded-full skeleton ring-1 ring-border" />
        <div className="min-w-0 flex-1 space-y-2">
          <div className="h-4 w-32 rounded skeleton" />
          {showMeta && (
            <div className="flex items-center gap-1">
              <span className="h-3 w-3 rounded-full skeleton shrink-0" aria-hidden />
              <span className="h-3 w-24 rounded skeleton" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
